import type { FaireProductEntity } from "../../entity_types/product";

export const p_ns2k5z2ujj: FaireProductEntity = {
  token: "p_ns2k5z2ujj",
  type: "product",
  name: "Grass-Fed Liver | Capsules (30 Servings)",
  brandToken: "b_at5l4qlr",
  brandName: "Ancient Nutrition",
  imageUrl:
    "https://cdn.faire.com/fastly/bfb9d821b662ee5d23f59f5520a271fe1995ebb98429085d965a440a7d0a5c98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f824bd23266f899a30702d3eaad1f6ca468ed1a4285f27652fd56d3960b77224.jpeg",
    "https://cdn.faire.com/fastly/5811d9daca96ab2665cbd7d9fd2d23ee757bb32860d530ffe3617da711c531a6.jpeg",
    "https://cdn.faire.com/fastly/d62f7b814ac988addde8bbd0b2d7b64cac41ad7b0aadae6926d76994fc68f044.jpeg",
    "https://cdn.faire.com/fastly/87c76a673c891f098f7a67d5949433d256551f297266c988f3d066537b3ac4ed.jpeg",
    "https://cdn.faire.com/fastly/785c1ebccb8102b1656e22e7a53da27db318ed7181762fbe6acc13d0189c19cc.jpeg",
    "https://cdn.faire.com/fastly/c9d6673d5c71c5ba621f000420a19d101e3f789b2984ae7cc6e567dc97dc4a4d.jpeg",
    "https://cdn.faire.com/fastly/dd046dcaa3dac75668ab2312a3e3b0cf2a4883da39bfdb3434e39aacf84d8cc0.jpeg",
  ],
  priceDollars: 23.97,
  description:
    "Let’s recapture what the modern diet lacks with the number 1 nutrient-filled superfood on the planet. This wild, grass-fed liver blend is packed with vitamins, minerals and more to promote optimal liver health.\n\n * Combines bovine & ovine liver with plants, mushroom & probiotics\n\n * Supports liver health & healthy blood† \n * Supports healthy detoxification† \n * Supports healthy energy metabolism, endurance & performance† \n * Supports healthy hormones† \n * Supports immune system health† \n * Reduces occasional constipation, gas & bloating† \n * Promotes healthy elimination & digestive function† \n * Adults take 6 capsules daily ",
  tags: [],
  msrpDollars: 39.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:34.020Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
